import Listagem from '../componentes/RelatorioEmplacamento/listagem';

function RelatorioFiliadoEmplacamento() {
  return (
    <Listagem></Listagem>
  );
}

export default RelatorioFiliadoEmplacamento;
